<script setup lang="ts">
import { AddressObj } from "@/modules/hotels/interfaces/tripadvisorDetails";
import { computed } from "vue";

interface Props {
  name: string;
  addressObj: AddressObj;
  titleClass?: string;
}

const props = defineProps<Props>();
const { city, state, country, addressString } = props.addressObj;
const locations = [city, state, country];

const locationString = computed(() => {
  return locations.filter((location) => location).join(", ");
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <span
      :class="['text-xl font-medium leading-6 text-gray-900 mb-2', titleClass]"
      >{{ name }}</span
    >

    <p class="text-sm font-bold">
      Ubicación: <span>{{ locationString }}</span>
    </p>
    <p class="text-sm font-bold">
      Direccion: <span>{{ addressString }}</span>
    </p>
  </div>
</template>

<style scoped></style>
